import {
  Page,
  Banner,
} from '@shopify/polaris';
import { useState, useCallback, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useOrderDetail } from '../hooks';
import OrderDetailContent from '../components/OrderDetailContent';
import PrintableOrderSheet from '../components/PrintableOrderSheet';

export default function OrderDetail() {
  const { orderId } = useParams();
  const navigate = useNavigate();

  // Fetch order data for Page title and secondary actions
  const { data } = useOrderDetail(orderId);
  const order = data?.order;
  const files = data?.files;

  // Print production sheet
  const printContainerRef = useRef<HTMLDivElement>(null);
  const [showPrintSheet, setShowPrintSheet] = useState(false);

  const handlePrint = useCallback(() => {
    setShowPrintSheet(true);
    setTimeout(() => {
      window.print();
      setTimeout(() => setShowPrintSheet(false), 500);
    }, 100);
  }, []);

  if (!orderId) {
    return (
      <Page title="Order Not Found">
        <Banner tone="critical">
          <p>Invalid order ID</p>
        </Banner>
      </Page>
    );
  }

  return (
    <Page
      title={order ? `${order.isDraft ? 'Draft ' : ''}Order ${order.shopifyOrderName}` : 'Loading...'}
      backAction={{ content: 'Orders', onAction: () => navigate('/orders') }}
      secondaryActions={order ? [
        {
          content: 'Print Production Sheet',
          onAction: handlePrint,
        },
        ...(order.isDraft && order.shopifyDraftOrderId ? [{
          content: 'Create Invoice',
          external: true,
          url: `https://admin.shopify.com/store/${order.shopDomain || 'sixhats'}/draft_orders/${order.shopifyDraftOrderId}`,
        }] : []),
        {
          content: 'View in Shopify',
          external: true,
          url: order.isDraft && order.shopifyDraftOrderId
            ? `https://admin.shopify.com/store/${order.shopDomain || 'sixhats'}/draft_orders/${order.shopifyDraftOrderId}`
            : `https://admin.shopify.com/store/${order.shopDomain || 'sixhats'}/orders/${order.shopifyOrderId}`,
        },
      ] : []}
    >
      <OrderDetailContent orderId={orderId} />

      {/* Printable production sheet (hidden on screen, shown when printing) */}
      {showPrintSheet && order && files && (
        <div ref={printContainerRef}>
          <PrintableOrderSheet order={order} files={files} />
        </div>
      )}
    </Page>
  );
}
